import { Link } from "@tanstack/react-router";

/**
 * 404 页面组件
 *
 * 当路由未找到时显示
 * 使用 fixed 定位覆盖整个页面，包括 Header
 */
export function NotFound() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md text-center">
        <div className="space-y-6 rounded-lg bg-white p-8 shadow-lg">
          <div className="flex justify-center">
            <svg
              className="h-24 w-24 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M12 12h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
              />
            </svg>
          </div>

          <div>
            <h1 className="mb-2 font-bold text-6xl text-gray-900">404</h1>
            <p className="mb-1 text-gray-600 text-xl">页面未找到</p>
            <p className="text-gray-500 text-sm">抱歉，您访问的页面不存在或已被移除</p>
          </div>

          <div className="pt-4">
            <Link
              className="inline-block rounded-md bg-info px-6 py-3 text-white transition-colors hover:bg-info"
              to="/"
            >
              返回首页
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
